import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import {
  ENUM_CUS_EVENT,
  ENUM_PROMO_FILL,
  ENUM_PROMOCODE_STATUS,
  statusOptions
} from '../../../enums/enums';
import { API_GROUP, API_USER } from '../../../api/user';
import { dispatchCusEvent, getOnlyData } from '../../../utils';
import useToast from '../../useToast';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { setPromocodeList } from '../../../store/apps/userSlice';

export default function useEditPromocode(groupId) {
  const group = useAppSelector((state) => state.user.group.hash?.[groupId]);
  const [status, setStatus] = useState(statusOptions[1].value);

  const defaultCurrency = group?.currency;
  const dispatch = useDispatch();
  const { successToast } = useToast();

  const promocodeInfo = useAppSelector((state) => state.user.promocode?.[groupId]) || [];

  const [promoUpdateTicker, setPromoUpdateTicker] = useState(0);

  const defaultNewPromo = {
    seriesName: '',
    totalCount: 1,
    useTimes: 1,
    prefix: '',
    expireDate: getOnlyData(dayjs().add(7, 'day'), '23:59:59'),
    currency: defaultCurrency,
    dateFrom: undefined,
    dateTo: undefined,
    minDeposit: 0,
    useCasinoTax: false,
    bonusAmount: 1,
    wager: 40,
    cashout: 3,
    toDeposit: false
  };

  const [chosenList, setChosenList] = useState([]);

  const listPromocodes = promocodeInfo?.list || [];
  const seriesOptions = promocodeInfo?.series?.map((el) => ({ label: el, value: el })) || [];

  const onDeactivate = () => {
    API_GROUP.bonus.promocode
      .setStatus(chosenList, ENUM_PROMOCODE_STATUS.disabled)
      .then(() => {
        successToast('Successfully deactivated');
        dispatchCusEvent(ENUM_CUS_EVENT.getPromoList, {
          groupId,
          status: status,
          fill: ENUM_PROMO_FILL.list,
          successFn: () => setPromoUpdateTicker(Math.random())
        });
      })
      .catch(console.error);
  };

  const onDelete = () => {
    console.log('onDelete');
    API_GROUP.bonus.promocode
      .setStatus(chosenList, ENUM_PROMOCODE_STATUS.deleted)
      .then(() => {
        dispatchCusEvent(ENUM_CUS_EVENT.getPromoList, {
          groupId,
          status: status,
          fill: ENUM_PROMO_FILL.list,
          successFn: () => setPromoUpdateTicker(Math.random())
        });
        successToast('Successfully deleted');
      })
      .catch(console.error);
  };

  const onCopyClipboard = async () => {
    // const bonuses = bonusPromocodes;
    let textPromo = '';
    for (let id of chosenList) {
      // console.log(bonuses, id);

      const bonus = listPromocodes.find((el) => el[0] === id);
      const promo = bonus[2];
      textPromo += `${promo} \n`;
    }
    await navigator.clipboard.writeText(textPromo);
  };

  const onCreate = (data) => {
    console.log('data', data);

    API_USER.group.bonus.promocode.series
      .add({ groupId, ...data })
      .then((e) => {
        dispatchCusEvent(ENUM_CUS_EVENT.getPromoList, { groupId, fill: ENUM_PROMO_FILL.series });
        successToast('Information updated successfully');
        const list = e.data.list;

        dispatch(setPromocodeList({ id: +groupId, data: [...list, ...promocodeInfo?.list] }));
        setPromoUpdateTicker(Math.random());
      })
      .catch(console.log);
  };

  useEffect(() => {
    if (listPromocodes.length) return;

    dispatchCusEvent(ENUM_CUS_EVENT.getPromoList, {
      groupId,
      status: status,
      successFn: () => setPromoUpdateTicker(Math.random())
    });
  }, [groupId]);

  return {
    listPromocodes,
    defaultCurrency,
    defaultNewPromo,
    chosenList,
    seriesOptions,
    promoUpdateTicker,
    status,
    setPromoUpdateTicker,
    setStatus,
    setChosenList,
    onDelete,
    onDeactivate,
    onCopyClipboard,
    onCreate
  };
}
